import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { SidebarComponent } from "../../common/sidebar/sidebar.component";
import { Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "../../common/header/header.component";
import { FooterComponent } from "../../common/footer/footer.component";
import { AdminDashboardComponent } from "../../admin-dashboard/admin-dashboard.component";
import { StudentDashboardComponent } from "../../student-dashboard/student-dashboard.component";
import { CustomizerSettingsService } from "../../customizer-settings/customizer-settings.service";
import { ToggleService } from "../../common/sidebar/toggle.service";

@Component({
  selector: "app-main-layout",
  standalone: true,
  imports: [
    CommonModule,
    SidebarComponent,
    RouterOutlet,
    HeaderComponent,
    AdminDashboardComponent,
    FooterComponent,
  ],
  templateUrl: "./main-layout.component.html",
  styleUrl: "./main-layout.component.scss",
})
export class MainLayoutComponent {
  isSidebarToggled: boolean = false;
  isToggled: boolean = false;

  constructor(
    public router: Router,
    private toggleService: ToggleService,

    public themeService: CustomizerSettingsService
  ) {
    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }
}
